import { DocumentTitle } from 'components/DocumentTitle';
import { DebouncedSearchInput } from 'components/data/DebouncedSearchInput';
import { TablePageLayout } from 'components/page/styled';
import { usePagedClientSoftwareDataSource } from 'custom_hooks/data_hooks/data_source/clientSoftwareDataSource';
import { clientSoftwareCopy } from 'pages/Settings/ClientSoftwareTags/clientSoftwareCopy';
import { ClientSoftwareTagsTable } from 'pages/Settings/ClientSoftwareTags/ClientSoftwareTagsTable';
import {
    SearchCreateButtonContainer,
    SettingsHeading,
} from 'pages/Settings/shared/styled';
import { useEffect, useState } from 'react';

export function ClientSoftwareTagsPage() {
    const dataSource = usePagedClientSoftwareDataSource({
        name: 'client-software-tags-table',
        defaultFilter: { nameSearch: '' },
    });

    const [nameSearch, setNameSearch] = useState('');
    const { setFilter } = dataSource;

    useEffect(() => {
        setFilter((currentFilter) => ({
            ...currentFilter,
            nameSearch,
        }));
    }, [nameSearch, setFilter]);

    return (
        <TablePageLayout>
            <DocumentTitle title="Client Software Settings" />
            <SettingsHeading style={{ paddingTop: '1.5rem' }}>
                Client Software
            </SettingsHeading>
            <span>{clientSoftwareCopy.pageDescription}</span>
            <span>{clientSoftwareCopy.tagsBehavior}</span>
            <SearchCreateButtonContainer>
                <DebouncedSearchInput
                    placeholder="Search"
                    value={nameSearch}
                    onChange={setNameSearch}
                />
            </SearchCreateButtonContainer>
            <ClientSoftwareTagsTable dataSource={dataSource} />
        </TablePageLayout>
    );
}
